import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from 'i18n/options';
import Flex, { Box } from 'components/Flex';
import TextLink from 'components/TextLink';
import Text from 'components/Text';
import TooltipButton from 'components/TooltipButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var languagesMap = languages.reduce(function (map, language) {
  map[language.value] = language.title_en;
  return map;
}, {});
function SubtitlesItem(_ref) {
  var isDisabled = _ref.isDisabled,
    subtitleFile = _ref.subtitleFile,
    isMutable = _ref.isMutable,
    onEdit = _ref.onEdit,
    onDelete = _ref.onDelete;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = subtitleFile.id,
    locale = subtitleFile.locale,
    name = subtitleFile.name,
    filename = subtitleFile.filename;
  var label = languagesMap[locale] || locale;
  return /*#__PURE__*/_jsxs(Flex, {
    background: "shaded",
    borderRadius: "small",
    overflow: "hidden",
    children: [/*#__PURE__*/_jsxs(Box, {
      grow: true,
      shrink: true,
      bold: true,
      position: "relative",
      overflow: "ellipsis",
      fontSize: "xs",
      lineHeight: 1.3,
      p: "xs",
      pl: "s",
      children: [/*#__PURE__*/_jsxs(TextLink, {
        stealthy: true,
        as: "button",
        onClick: function onClick() {
          return onEdit({
            subtitleFile: subtitleFile
          });
        },
        isDisabled: isDisabled,
        children: [/*#__PURE__*/_jsx(Box, {
          fillParent: true,
          z: function z(theme) {
            return theme.globals.z.raised - 1;
          }
        }), label]
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        dimmed: true,
        bold: false,
        children: name || filename
      })]
    }), isMutable && /*#__PURE__*/_jsx(Box, {
      pr: "xs",
      children: /*#__PURE__*/_jsx(TooltipButton, {
        size: "small",
        variant: "transparent",
        icon: "x",
        title: "".concat(t('actions_delete'), " ").concat(label),
        tooltipPlacement: "top-end",
        onClick: function onClick() {
          return onDelete({
            id: id
          });
        },
        isDisabled: isDisabled
      })
    })]
  });
}
export default SubtitlesItem;